import * as React from 'react';
import './otherDrawerComponentThree.css';
import './DrawerComponentThree.css';
import { useState, useEffect } from "react";
import Box from '@mui/material/Box';
import List from '@mui/joy/List';
import ListItem from '@mui/joy/ListItem';
import { getLoggedInFlag, getMUICache, safeCharAt, fetchAnchorValue, getAnchorUrl, GetIconsSprites } from "../../../common/utils";
import ListItemButton from '@mui/joy/ListItemButton';
import { Button, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
// import { FrontAwesomeIcon } from '@fortawesome/react-frontawesome';
// import { faXmark } from '@fortawesome/free-solid-svg-icons';
import InputAdornment from '@mui/material/InputAdornment';
import { CacheProvider } from '@emotion/react';
import { handleSearchClick, getLoggedUserName, getLoggedUserEmail, logoutUser } from "../../../common/utils";

export default function DrawerComponentThree(props) {
  const { toggleMainMenu, menuItems, domainUrl, HamburgerTextColor, HamburgerBgColor, hostId, anchorLinksValue } = props;
  const [searchValue, setSearchValue] = useState("");
  const [loggedUserName, setLoggedUserName] = useState("");
  const [loggedUserEmail, setLoggedUserEmail] = useState("");
  const [loginLink, setLoginLink] = useState("");
  const [loginEnabled, setLoginEnabled] = useState(false);
  // const [menuOpen, setMenuOpen] = useState(false); // Track menu open/close state

  // const endpointHostId = getEndpoint(props, "HEADER_MENU_API");
  // const hostId = endpointHostId.queryParams.hostId;

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSearchClick(searchValue, hostId);
    }
  }

  if (!loginEnabled && props && props.transportData && props.transportData.isLoginEnabled) {
    setLoginEnabled(props.transportData.isLoginEnabled);
  }

  const toggleMenu = () => {
    document.body.classList.remove("modal-open");
  };
  useEffect(() => {
    setLoggedUserName(getLoggedUserName());
    setLoggedUserEmail(getLoggedUserEmail());
    setLoginLink("/login?url=" + encodeURIComponent(window.location.href));
    if (!loginEnabled && props && props.transportData && props.transportData.isLoginEnabled) {
      setLoginEnabled(props.transportData.isLoginEnabled);
    }
    setLoginEnabled(getLoggedInFlag());
  }, []);

  // Determine if the email exists
  const hasUserEmail = !!loggedUserEmail;
  const getLoginString = () => {
    if (loginEnabled) {
      if (loggedUserName) {
        return (
          <>
            <div className="ThemeThreeWelcomeWrapperMobile">
              <button className="ThemeThreeAfterLoginButtonMobile">
                {safeCharAt(loggedUserName)}
              </button>

              <div className="ThemeTwoWelcomeUserDetails">
                <li className="UserNameAfterLogIn">{loggedUserName}</li>
                <li className="UserEmailAfterLogIn">{loggedUserEmail}</li>
              </div>
            </div>
            {/* <div className="ThemeThreeListLogMobile">
                  <li>
                    {" "}
                    <a onClick={logoutUser} href="javascript:void(0)">
                      Logout
                    </a>
                  </li>
                </div> */}
          </>
        );
      }
      return (
        <div className="ThemeThreeLoginWrapperMobile">
          <a href={loginLink} className="ThemeThreeLoginAnchorMobile">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0 4C0 1.79086 1.79086 0 4 0H28C30.2091 0 32 1.79086 32 4V28C32 30.2091 30.2091 32 28 32H4C1.79086 32 0 30.2091 0 28V4Z"
                fill="#F29D38"
              />
              <mask id="path-2-inside-1_13_3229" fill="white">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M20.33 18.45C21.6914 18.45 22.9971 18.9908 23.9598 19.9535C24.9225 20.9162 25.4633 22.2219 25.4633 23.5833V25.75L25.4571 25.8503C25.4077 26.2448 25.0712 26.55 24.6633 26.55C24.2215 26.55 23.8633 26.1918 23.8633 25.75V23.5833C23.8633 22.6462 23.4911 21.7475 22.8284 21.0849L22.6714 20.9372C22.0273 20.3672 21.195 20.05 20.33 20.05H11.6634L11.4479 20.0566C10.5894 20.109 9.77658 20.4732 9.16492 21.0849C8.50229 21.7475 8.13003 22.6462 8.13003 23.5833V25.75L8.1238 25.8503C8.07443 26.2448 7.73787 26.55 7.33003 26.55C6.8882 26.55 6.53003 26.1918 6.53003 25.75V23.5833L6.53634 23.3288C6.59928 22.06 7.13103 20.856 8.03355 19.9535C8.99623 18.9908 10.3019 18.45 11.6634 18.45H20.33Z"
                />
              </mask>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M20.33 18.45C21.6914 18.45 22.9971 18.9908 23.9598 19.9535C24.9225 20.9162 25.4633 22.2219 25.4633 23.5833V25.75L25.4571 25.8503C25.4077 26.2448 25.0712 26.55 24.6633 26.55C24.2215 26.55 23.8633 26.1918 23.8633 25.75V23.5833C23.8633 22.6462 23.4911 21.7475 22.8284 21.0849L22.6714 20.9372C22.0273 20.3672 21.195 20.05 20.33 20.05H11.6634L11.4479 20.0566C10.5894 20.109 9.77658 20.4732 9.16492 21.0849C8.50229 21.7475 8.13003 22.6462 8.13003 23.5833V25.75L8.1238 25.8503C8.07443 26.2448 7.73787 26.55 7.33003 26.55C6.8882 26.55 6.53003 26.1918 6.53003 25.75V23.5833L6.53634 23.3288C6.59928 22.06 7.13103 20.856 8.03355 19.9535C8.99623 18.9908 10.3019 18.45 11.6634 18.45H20.33Z"
                fill="black"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.7865 15.7122C13.052 15.5985 10.8701 13.3457 10.8701 10.5833L10.8746 10.3663C10.9883 7.63192 13.2411 5.45 16.0034 5.45L16.2204 5.4545C18.9549 5.56821 21.1368 7.82096 21.1368 10.5833L21.1323 10.8003C21.0186 13.5347 18.7658 15.7167 16.0034 15.7167L15.7865 15.7122ZM16.1973 14.1114C18.0586 14.0108 19.5368 12.4697 19.5368 10.5833L19.5316 10.3895C19.4309 8.52822 17.8898 7.05 16.0034 7.05L15.8096 7.05523C13.9483 7.15587 12.4701 8.69697 12.4701 10.5833L12.4753 10.7772C12.576 12.6384 14.1171 14.1167 16.0034 14.1167L16.1973 14.1114Z"
                fill="black"
              />
            </svg>{" "}
            <span>login</span>
          </a>
        </div>
      );
    }
  };

  return (
    <>
      {

        <CacheProvider value={getMUICache()}>
          <div className="navoverlay" />
          <div className='withLogoutButtonOtherPage'>
            <Box className="sidenav mobileSideNav" style={{ backgroundColor: HamburgerBgColor }} sx={{ top: "0", position: "fixed", zIndex: "9" }} role="presentation" >
              <div className='themethreeotherheadermobile'>
                <Button className="closebtn" onClick={() => { toggleMainMenu(); toggleMenu(); }}>
                  {/* <FrontAwesomeIcon icon={faXmark} /> */}
                  <div className='bg-Close_icon_black' style={{ backgroundImage: `url(${GetIconsSprites()})` }}></div>
                </Button>
              </div>
              <div className="ThemeThreeMainLoginFunctionWrapMobile">
                {getLoginString()}
              </div>
              {/* <div class="sidemenu-search-box">
                            
                            <div className="form-group">
                                <TextField id="" placeholder='Type Search here' onKeyPress={(e) => handleKeyPress(e)}  onChange={e => setSearchValue(e.target.value)} type='search' variant="filled" fullWidth
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end"><SearchIcon onClick={() => handleSearchClick(searchValue)} /></InputAdornment>
                                    }}
                                />
                            </div>
                        </div> */}
              <div className='themethreeotherpahemobilemenu'>
                <List orientation="horizontal"
                  sx={{
                    '--List-padding': '0px',
                    '--List-gap': '0px',
                    '--ListItem-paddingX': '0px',
                    '--ListItem-paddingY': '0px',
                    padding: "0"
                  }}>

                  {
                    (Array.isArray(menuItems) ? menuItems : []).map((val, index) => {
                      let path = val.path;
                      if (val.type === 2) {
                        path = '/tags/' + (val.tagpath !== undefined ? val.tagpath : '');
                      }
                      return <ListItem key={index} role="none">
                        <ListItemButton component="a" href={getAnchorUrl(domainUrl, path)} target={fetchAnchorValue(anchorLinksValue, path)} style={{ color: HamburgerTextColor }}>{val.name}</ListItemButton>
                        {val.sections &&
                          val.sections.map((dataItem, index) => {
                            let pathInternal = dataItem.path;
                            if (dataItem.type === 2) {
                              pathInternal = '/tags/' + (dataItem.tagpath !== undefined ? dataItem.tagpath : '');
                            }
                            return <List key={index} component="ul" disablePadding className='sub-menu'>
                              <ListItem>
                                <ListItemButton key={'1_' + index} component="a" href={getAnchorUrl(domainUrl, pathInternal)} target={fetchAnchorValue(anchorLinksValue, pathInternal)} style={{ color: HamburgerTextColor }}>{dataItem.name}</ListItemButton>
                              </ListItem>
                            </List>
                          })

                        }
                      </ListItem>
                    })
                  }
                </List>
              </div>
            </Box>


            <div className="ThemeThreeListLogMobile">
              <li>
                {" "}
                <a onClick={logoutUser} href="javascript:void(0)" className={`logoutLink ${hasUserEmail ? "emailExists" : ""}`}>Logout</a>
              </li>
            </div>
          </div>
        </CacheProvider>
      }
    </>
  );
}